import React, { useEffect, useState } from 'react';
import { Progress } from './progress';
import { cn } from '../../lib/utils';

interface ModelLoaderProps {
  progress: number;
  ready: boolean;
}

const ModelLoader: React.FC<ModelLoaderProps> = ({ progress, ready }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (ready) {
      const t = setTimeout(() => setVisible(false), 600);
      return () => clearTimeout(t);
    }
  }, [ready]);

  if (!visible) return null;

  return (
    <div
      className={cn(
        'fixed inset-0 z-50 flex flex-col items-center justify-center bg-[#0a0a0a] transition-opacity duration-700',
        ready ? 'opacity-0 pointer-events-none' : 'opacity-100'
      )}
    >
      <p className="mb-1 text-[0.6rem] font-semibold tracking-[0.22em] uppercase text-white/25">
        EuroJDM
      </p>
      <p className="mb-8 text-[0.55rem] tracking-[0.18em] uppercase text-white/15">
        Loading
      </p>

      <div className="w-48">
        <Progress
          value={progress}
          className="h-[2px] bg-white/8 rounded-none"
        />
      </div>

      <p className="mt-4 text-[0.55rem] tabular-nums tracking-widest text-white/20">
        {Math.round(progress)}%
      </p>
    </div>
  );
};

export default ModelLoader;
